import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({ providedIn: 'root' })
export class OfflineNotificationService {
  private readonly toastr = inject(ToastrService);
  private readonly translate = inject(TranslateService);

  notifyFeatureUnavailable(): void {
    this.toastr.error(
      this.translate.instant('common.offline_unavailable.message'),
      this.translate.instant('common.offline_unavailable.title')
    );
  }
}
